var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-fill flex-column slo-plan-panel"},[_c('Message',{attrs:{"messageModel":"sloJournal","params":{
            slo_id: _vm.slo.id
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }